module.exports = __webpack_public_path__ + "static/media/Cox-bazar.c530f679.png";